import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import { map } from 'lodash'
import PropTypes from 'prop-types'

import { WarnIcon } from '../../icons'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '& td, & th': {
    padding: theme.spacing(1),
    border: 0,
  },
}))

function CarWorkTodo({ digitalCertificate }) {
  const { technicalConditions } = digitalCertificate
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="h3" sx={{ mb: 2 }}>
        {t('carControl.todo')}
      </Typography>
      <Table>
        <TableBody>
          {map(technicalConditions.getTechnicalConditionGroupModel, (group) =>
            map(
              group.technicalChecklistGroupElements,
              (elem, key) =>
                elem.technicalConditionStatus === 'NotOk' && (
                  <StyledTableRow key={key}>
                    <TableCell>
                      <Box sx={{ display: 'flex' }}>
                        <Box
                          sx={(theme) => ({
                            color: theme.palette.warning.main,
                          })}
                        >
                          <WarnIcon />
                        </Box>
                        <Box sx={{ ml: 1 }}>
                          <Typography>
                            {elem.technicalChecklistItemName}
                          </Typography>
                          {elem.description && (
                            <Typography
                              component="span"
                              variant="body2"
                              sx={({ palette }) => ({
                                color: palette.text.disabled,
                              })}
                            >
                              {elem.description}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </TableCell>
                  </StyledTableRow>
                ),
            ),
          )}
        </TableBody>
      </Table>
    </Box>
  )
}

CarWorkTodo.propTypes = {
  digitalCertificate: PropTypes.object,
}

CarWorkTodo.defaultProps = {
  digitalCertificate: {},
}

export default CarWorkTodo
